import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('StatusChangeLogEntry')
export class StatusChangeLogEntry {
  @JsonProperty('timestamp', String, true) timestamp: string = undefined;
  @JsonProperty('fromStatus', String, true) fromStatus: string = undefined;
  @JsonProperty('toStatus', String, true) toStatus: string = undefined;
  @JsonProperty('forced', Boolean, true) forced: boolean = undefined;
}
